import { FormControlLabel } from '@material-ui/core';
import Switch from '@material-ui/core/Switch';
import clsx from 'clsx';
import React, { memo } from 'react';

import styles from './DrillxToggle.module.scss';

export interface Prop {
  onChange: (event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => void;
  checked: boolean;
  label: string;
}

const DrillxToggle: React.FC<Prop> = ({ onChange, checked, label }) => {
  return (
    <FormControlLabel
      label={label}
      classes={{ label: clsx(styles.label, checked ? styles.activeLabel : styles.inactiveLabel) }}
      checked={checked}
      control={
        <Switch
          onChange={onChange}
          color="default"
          classes={{ switchBase: styles.switch, checked: styles.checked, track: styles.track }}
        />
      }
    />
  );
};

export default memo(DrillxToggle);
